module.exports = function() {
  return new Worker(__webpack_public_path__ + "77387f50208cc85ba944.worker.js");
};